import { FC, useMemo, useState } from "react";
import { useAppContext } from "../../../../../../context/app.context";
import orderDetailsManageDriverAssignmentSimulationTableHelper from "./order-details-manage-driver-assignment-simulation-table.helper";
import {
  OrderCargoOrderDriverSimulationSimulation,
  OrderCargoOrderDriverSimulationSimulations,
} from "../../../../../../common/services/order/cargo-order/driver-simulation/order-cargo-order-driver-simulation";
import OrderDetailsManageDriverAssignmentSimulationTableRow from "./types/order-details-manage-driver-assignment-simulation-table-row";
import TableComponent from "../../../../../../common/components/table/table.component";
import NumericInputComponent from "../../../../../../common/components/form/input/numeric-input/numeric-input.component";

type Model = "AB" | "ABA" | "SABS";

type Props = {
  driverName: string;
  simulations: OrderCargoOrderDriverSimulationSimulations;
  chosenModel: Model;
};

const OrderDetailsManageDriverAssignmentSimulationTableComponent: FC<Props> = (
  props,
) => {
  const { selectedAppLanguage } = useAppContext();

  const [bonuses, setBonuses] = useState<Record<Model, number | null>>({
    AB: props.simulations.ab.bonusRate,
    ABA: props.simulations.aba.bonusRate,
    SABS: null,
  });

  const columns = useMemo(
    () => orderDetailsManageDriverAssignmentSimulationTableHelper.getColumns(),
    [selectedAppLanguage],
  );

  const createTableRow = (
    simulation: OrderCargoOrderDriverSimulationSimulation,
    model: Model,
  ): OrderDetailsManageDriverAssignmentSimulationTableRow => {
    const isChosen = model === props.chosenModel;

    const distanceLabel =
      orderDetailsManageDriverAssignmentSimulationTableHelper.getDistanceLabel(
        simulation.distance,
      );

    const totalCostLabel =
      orderDetailsManageDriverAssignmentSimulationTableHelper.getCostLabel(
        simulation.totalCost,
        bonuses[model],
        simulation.distance,
      );

    const sabsBonusLabel =
      orderDetailsManageDriverAssignmentSimulationTableHelper.getNoValueLabel();

    return {
      id: model,
      value: {
        driver: <div title={props.driverName}>{props.driverName}</div>,
        model: (
          <div title={model} className={isChosen ? "chosen_model" : ""}>
            {model}
          </div>
        ),
        rate: (
          <NumericInputComponent
            value={simulation.contractRate}
            decimalPrecision={2}
            isDisabled
          />
        ),
        bonus:
          model === "SABS" ? (
            <div title={sabsBonusLabel}>{sabsBonusLabel}</div>
          ) : (
            <NumericInputComponent
              value={bonuses[model]}
              decimalPrecision={2}
              onChange={(value) => setBonuses({ ...bonuses, [model]: value })}
            />
          ),
        distance: <div title={distanceLabel}>{distanceLabel}</div>,
        cost: <div title={totalCostLabel}>{totalCostLabel}</div>,
      },
    };
  };

  const rows = useMemo(
    () => [
      createTableRow(props.simulations.ab, "AB"),
      createTableRow(props.simulations.aba, "ABA"),
      createTableRow(props.simulations.sabs, "SABS"),
    ],
    [selectedAppLanguage, bonuses],
  );

  return (
    <div className="order_details_manage_driver_assignment_extended_simulator_table">
      <TableComponent columns={columns} rows={rows} />
    </div>
  );
};

export default OrderDetailsManageDriverAssignmentSimulationTableComponent;
